import React from "react";

import { Stack, StackProps, Typography } from "@mui/material";

export const DialogHead = React.forwardRef<
  HTMLDivElement,
  StackProps & {
    title: string;
    text: string;
  }
>(({ title, text, ...props }, ref) => {
  return (
    <Stack ref={ref} {...props}>
      {title ? (
        <Typography
          align="center"
          color="primary"
          component="h1"
          gutterBottom
          style={{ textWrap: "balance" }}
          variant="h2"
        >
          {title}
        </Typography>
      ) : null}
      {text ? (
        <Typography
          align="center"
          color="text.secondary"
          component="p"
          sx={{ textWrap: "balance", fontWeight: 500 }}
          variant="h5"
        >
          {text}
        </Typography>
      ) : null}
    </Stack>
  );
});

DialogHead.displayName = "DialogHead";
